import styled, { css } from 'styled-components';

// Z-INDEX DATA-GUIDE
// LeftSidebar - 9
// RightSidebar - 9
// SideNav - 10

export const StyledChrome = styled.div`
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-top: ${({ theme }) => theme.headerHeight};
  background: ${({ theme }) => theme.header};

  /* Inner corner belongs to the chrome, not the scrolling page. */
  &::before,
  &::after {
    content: '';
    position: fixed;
    z-index: 10;
    pointer-events: none;
    top: ${({ theme }) => theme.headerHeight};
    width: ${({ theme }) => theme.chromeRadius};
    height: ${({ theme }) => theme.chromeRadius};
    background: ${({ theme }) => theme.header};
  }
  &::before {
    left: 60px;
    background: radial-gradient(
      circle at 100% 100%,
      transparent ${({ theme }) => theme.chromeRadius},
      ${({ theme }) => theme.header} ${({ theme }) => theme.chromeRadius}
    );
    @media screen and (max-width: 1199px) {
      left: 0;
    }
    ${({ theme }) =>
      theme.chromeRadius === '0px' &&
      css`
        display: none;
      `}
  }
  &::after {
    display: none;
    right: 0;
    background: radial-gradient(
      circle at 0 100%,
      transparent ${({ theme }) => theme.chromeRadius},
      ${({ theme }) => theme.header} ${({ theme }) => theme.chromeRadius}
    );
    @media screen and (max-width: 1199px) {
      display: ${({ theme }) =>
        theme.chromeRadius === '0px' ? 'none' : 'block'};
    }
  }
`;

export const StyledMain = styled.section`
  position: relative;
  z-index: 1;
  flex: 1;
  min-height: 0;
  box-sizing: border-box;
  transition: margin-left 0.2s, margin-right 0.2s;
  padding: 30px 45px;
  margin-left: 60px;
  background: ${({ theme }) => theme.page};
  border: 0;
  border-top-left-radius: ${({ theme }) => theme.chromeRadius};
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  @media screen and (min-width: 1200px) and (max-width: 1300px) {
    padding: 30px 15px;
  }
  @media screen and (max-width: 1199px) {
    width: 100%;
    max-width: none;
    margin-left: 0;
    margin-right: 0;
    padding: ${({ showHeader }) => (showHeader ? '56px' : '8px')} 12px 24px;
    border-top-right-radius: ${({ theme }) => theme.chromeRadius};
  }

  &[data-sideopen='true'] {
    &[data-right='true'] {
      margin-left: 0;
    }
  }
  &[data-sideopen='false'] {
    &[data-right='true'] {
      margin-left: 50px;
      @media only screen and (max-width: 1199px) {
        margin-left: 0;
      }
    }
  }
  &[data-right='true'] {
    margin-right: 300px;
    border-top-right-radius: 0;
    @media screen and (max-width: 1199px) {
      margin-right: 0;
    }
  }
`;

export const StyledBackground = styled.div`
  ${({ screenHeight }) => css`
    height: ${screenHeight};
  `}
`;
